export const enum TIMEZONES {
  MOSCOW = 'Etc/GMT-3',
}
